import {css, cx} from "@panda/css";

import {CenterBox} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";

interface IProps {
    className?: string;
    height?: string;
    inChrome?: boolean;
}

export const FullPageLoader = (props: IProps) => {
    const {className, height = "100vh", inChrome = false} = props;

    if (inChrome) {
        return (
            <div className={cx(className, authenticatedChromeLoaderStyle)} data-km-bottom-nav-follow="offset">
                <Loader size="lg" />
            </div>
        );
    }

    return (
        <CenterBox className={className} height={height}>
            <Loader size="lg" />
        </CenterBox>
    );
};

const authenticatedChromeLoaderStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: "6rem",

    md: {
        bottom: 0,
        left: "28.8rem",
        top: 0
    }
});
import {css, cx} from "@panda/css";

import {CenterBox} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";

interface IProps {
    className?: string;
    height?: string;
    inChrome?: boolean;
}

export const FullPageLoader = (props: IProps) => {
    const {className, height = "100vh", inChrome = false} = props;

    if (inChrome) {
        return (
            <div className={cx(className, authenticatedChromeLoaderStyle)} data-km-bottom-nav-follow="offset">
                <Loader size="lg" />
            </div>
        );
    }

    return (
        <CenterBox className={className} height={height}>
            <Loader size="lg" />
        </CenterBox>
    );
};

const authenticatedChromeLoaderStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: "6rem",

    md: {
        bottom: 0,
        left: "28.8rem",
        top: 0
    }
});
